/**
 * Right-sizes a Prismic (imgix) image URL so the CDN serves a scaled image instead
 * of the full-resolution original. This is the main lever against Prismic bandwidth
 * overage — stored originals run ~10-40x larger than the size they display at.
 *
 * IMPORTANT: many Prismic URLs already carry a baked-in `w=`/`h=` (a stored crop,
 * e.g. `...&rect=0,0,2028,1000&w=2028&h=1000`). We must REPLACE those, not append a
 * second `w=` — imgix honors the pre-existing large one and the cap is silently
 * ignored. So we strip any existing w/h/dpr and set our own, while keeping the crop
 * (`rect`), `auto=format,compress`, `fit`, etc.
 */
export const optimizeImageUrl = (url, width = 600, quality = 75) => {
  if (!url) return "";
  const [base, query = ""] = url.split("?");
  const kept = query
    .split("&")
    .filter(Boolean)
    .filter((p) => !/^(w|h|dpr)=/i.test(p)); // drop baked-in size params
  kept.push(`w=${width}`, `q=${quality}`);
  return `${base}?${kept.join("&")}`;
};
